import { Controller } from "@hotwired/stimulus"

// JSON editor controller with validation
export default class extends Controller {
  static targets = ["input", "status"]

  connect() {
    this.validate()
  }

  validate() {
    if (!this.hasInputTarget || !this.hasStatusTarget) return

    const value = this.inputTarget.value.trim()
    
    if (value === "") {
      this.setStatus("empty", "Empty (will be null)")
      return
    }

    try {
      JSON.parse(value)
      this.setStatus("valid", "✓ Valid JSON")
    } catch (e) {
      this.setStatus("invalid", `✗ Invalid JSON: ${e.message}`)
    }
  }

  setStatus(type, message) {
    this.statusTarget.className = `json-status json-status-${type}`
    this.statusTarget.textContent = message
  }

  format(event) {
    if (event) event.preventDefault()
    
    if (!this.hasInputTarget) return

    const value = this.inputTarget.value.trim()
    if (value === "") return

    try {
      const parsed = JSON.parse(value)
      this.inputTarget.value = JSON.stringify(parsed, null, 2)
      this.validate()
    } catch (e) {
      // Can't format invalid JSON
    }
  }
}
